export class FilterCriteria {

  subjectId: string = "";
  yearNumber: number = 0;
  sourceId: string = "";
  contentType: string = "";
  languageId: string = "";
  gradeName: string = "";
  classId: string = "";
}